import { Component, OnInit } from '@angular/core';
import { SaveService } from '../services/save.service';

@Component({
  selector: 'app-accordian',
  templateUrl: './accordian.component.html',
  styleUrls: ['./accordian.component.css']
})
export class AccordianComponent implements OnInit {

  //-------- brand details ------------
  public Brand_Name;
  public Brand_URL;
  public Brand_Email;

  constructor(public SaveService: SaveService) { }

  ngOnInit() {
    this.Brand_Name = this.SaveService.getBrandName();
    this.Brand_URL = this.SaveService.getBrandUrl();
    this.Brand_Email = this.SaveService.getBrandEmail();    
  }

}
